import React from "react";
import styled from "styled-components";

const ModelItem = ({ data }) => {
  return (
    <Model>
      <ModelItemImg>
        <Img src={data.image.publicURL}></Img>
      </ModelItemImg>
      <ModelItemContent>
        <ModelItemContentTitle>
          <h3>{data.title}</h3>
        </ModelItemContentTitle>
        <ServiceContent>
          <p>{data.text}</p>
        </ServiceContent>
      </ModelItemContent>
    </Model>
  );
};

const Model = styled.div`
  display: -ms-flex;
  display: -webkit-box;
  display: flex;
  -ms-justify-content: space-between;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin-bottom: 2.875rem;
  transition: background 2s;
  @media (max-width: 980px) {
    align-items: center;
    flex-direction: column;
    background: #dcdcdc;
    border-radius: 10px;
  }
`;
const ServiceContent = styled.div`
  font-weight: 400;
  color: #3d3d3d;
  font-size: 1rem;
  line-height: 1.25;
  margin-bottom: 3.5rem;

  & p {
    margin-bottom: 1rem;
    font-size: 15px;
  }
`;

const Img = styled.img.attrs((props) => ({
  src: props.src,
}))`
  max-width: 100%;
  height: auto;
  display: block;
  margin: 1.5rem 0;
`;

const ModelItemContent = styled.div`
  width: 54%;
  padding: 1.5rem;
  @media (max-width: 980px) {
    color: #fff;
    flex-direction: column;
    width: 100%;
  }
`;
const ModelItemContentTitle = styled.div`
  font-family: 'Archivo';
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  line-height: 0.95;
  color: #3d3d3d;
  margin-bottom: 1rem;
  & h3 {
    font-size: inherit;
    font-weight: inherit;
    margin-bottom: 0;
    line-height: inherit;
  }

  & h1 {
    font-family: 'Archivo';
    font-weight: 700;
    text-transform: uppercase;
    text-align: left;
    color: #3d3d3d;
    margin-left: 12px;
    font-size: 1.5rem;
    line-height: 1;
    margin-bottom: 2rem;
  }
`;

const ModelItemImg = styled.div`
  width: 40%;
`;

export default ModelItem;
